// extracted by mini-css-extract-plugin
module.exports = {"snackBar":"main_snackBar__2xJJc"};